import { select } from 'redux-saga/effects';

import { getInDomain } from '../../domains/externalUtils';

export function* isAPS({ payload: { sourceId } }) {
  return yield select(getInDomain('playback.utils.isPlaylistModelTypeAPSItem', false), sourceId);
}
